/**
 * UI feature flags.
 *
 * Prefer small, boolean, reversible switches here. When a feature matures
 * and the flag is no longer load-bearing, delete it — don't let them accumulate.
 */

/** When false, the UI exposes no path to sign up and the /signup route
 *  renders a "request access" screen instead of the Cognito form. Flip
 *  back to true when we open public signups again. */
export const SIGNUPS_ENABLED = false;

/** Where "request access" CTAs send the user when SIGNUPS_ENABLED is false. */
export const REQUEST_ACCESS_MAILTO = 'mailto:hello@nirvik.ai?subject=Trinetra%20access%20request';
